<template>
	<v-card :key="page_key" class="ma-2 elevation-0" color="grey lighten-4">
		<v-card-title class="secondary--text"> <v-icon large @click="goBack"> keyboard_arrow_left </v-icon> Locum Profile </v-card-title>

		<v-row v-for="(value, key) in titles" :key="key">
			<v-row>
				<v-card-title class="ml-16 mt-6 secondary--text text-subtitle-1 font-weight-bold">{{ value + ':' }}</v-card-title>
			</v-row>
			<v-card-text v-if="key != 'uploadedDocuments'">
				<v-row v-for="field in locumFields[key]" :key="'locum.' + field + '.' + page_key" class="pa-2 justify-center text-center">
					<v-card width="80%">
						<v-row>
							<v-col>
								<v-card-text class="font-weight-bold">{{ field + ':' }}</v-card-text>
							</v-col>
							<v-col>
								<v-card-text class="font-weight-bold">{{ locum[field] }}</v-card-text>
							</v-col>
						</v-row>
					</v-card>
				</v-row>
			</v-card-text>
			<v-card-text v-else>
				<v-row v-for="field in locumFields[key]" :key="'locum.' + field + '.' + page_key" class="pa-2 justify-center text-center">
					<v-card width="80%">
						<v-row>
							<v-col>
								<v-card-text class="font-weight-bold">{{ field + ':' }}</v-card-text>
							</v-col>
							<v-col>
								<v-progress-circular v-if="!docsLoaded && !imgsLoaded[field]" class="mt-3" indeterminate></v-progress-circular>
								<v-img
									:style="imgsLoaded[field] ? 'display: flex' : 'display: none'"
									aspect-ratio="2"
									:src="'data:image/png;base64,' + path[field]"
									@load="imgLoad(field)"
								></v-img>
								<v-col v-if="!imgsLoaded[field] && docsLoaded && path[field]" class="justify-center text-center">
									<a :href="'data:application/pdf;base64,' + path[field]" :download="field" class="font-weight-bold">Download document</a>
								</v-col>
								<v-card-text v-if="docsLoaded && !imgsLoaded[field] && !path[field]" class="font-weight-bold">No document has been uploaded</v-card-text>
							</v-col>
						</v-row>
					</v-card>
				</v-row>
			</v-card-text>
		</v-row>

		<v-card-actions class="justify-center text-center">
			<v-btn v-if="('approved' in locum && locum.approved == false) || !('approved' in locum)" class="white--text" color="primary" rounded @click="approveLocum"
				>Approve</v-btn
			>
			<v-btn v-else class="white--text" color="primary" rounded @click="unapproveLocum">Unapprove</v-btn>

			<v-dialog v-model="desireResetLocumPassword" width="500">
				<template #activator="{ on, attrs }">
					<v-btn class="white--text" color="primary" rounded v-bind="attrs" v-on="on"> Reset Password </v-btn>
				</template>

				<v-card :loading="desireResetLocumPasswordLoading">
					<v-card-title class="headline grey lighten-2"> Confirm Reset Locum Password </v-card-title>
					<v-card-text>Are you sure you wish to reset the password for user {{ locum.first_name }} {{ locum.last_name }}?</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-btn class="white--text" color="primary" rounded @click="desireResetLocumPassword = false"> NO </v-btn>
						<v-spacer></v-spacer>
						<v-btn class="white--text" color="primary" rounded @click="doResetPassword"> I AM SURE </v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card-actions>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import axios from 'axios';
import store from '@/store';

export default {
	name: 'LocumSearchTool',
	components: {},
	data: () => ({
		page_key: 0,
		local_locum: {},
		locum: {},
		desireResetLocumPassword: false,
		desireResetLocumPasswordLoading: false,
		docsLoaded: false,
		fieldsNames: [
			'professional_number',
			'professional_body',
			'short_bio',
			'isDeleted',
			'updatedBy',
			'email',
			'createdBy',
			'locations',
			'approved',
			'payment_info',
			'id',
			'willing_to_travel',
			'experience',
			'terms_conditions',
			'contact',
			'idpassport',
			'createdAt',
			'address',
			'isActive',
			'last_name',
			'qualifications',
			'working_hours',
			'updatedAt',
			'first_name',
		],

		locums: [],
		locumFields: {
			personalDetails: ['first_name', 'last_name', 'idpassport', 'email', 'contact', 'address', 'payment_info'],
			professionalDetails: [
				'industry',
				'profession',
				'professional_number',
				'qualifications',
				'experience',
				'working_hours',
				'locations',
				'skills',
				'willing_to_travel',
				'short_bio',
				'indemnity_insurance',
			],
			userDetails: ['id', 'tenantId', 'isDeleted', 'isActive', 'approved', 'registered_date', 'createdAt', 'createdBy', 'updatedAt', 'updatedBy'],
			uploadedDocuments: ['idDocument', 'profilePicture', 'provisionalTax', 'profIndemnity'],
		},
		documents: {
			idDocument: { doctype: 'identity_document', show: true },
			profilePicture: { doctype: 'avatar', show: true },
			provisionalTax: { doctype: 'provisionalTaxFile', show: true },
			profIndemnity: { doctype: 'indemnityInsuranceFile', show: true },
		},
		path: {
			idDocument: null,
			profilePicture: null,
			provisionalTax: null,
			profIndemnity: null,
		},
		imgsLoaded: {
			idDocument: false,
			profilePicture: false,
			provisionalTax: false,
			profIndemnity: false,
		},
		titles: { personalDetails: 'Personal Details', professionalDetails: 'Professional Details', userDetails: 'User Details', uploadedDocuments: 'Uploaded Documents' },
	}),

	async mounted() {
		this.locum = store.getters.getAdminViewingLocum;

		let listOfDocs = Object.keys(this.documents);
		for (const item of listOfDocs) {
			this.path[item] = await this.getDocs(this.documents[item].doctype);
		}

		setTimeout(() => {
			this.docsLoaded = true;
		}, 2000);
	},
	created() {},
	beforeDestroy() {},
	methods: {
		async doResetPassword() {
			this.desireResetLocumPasswordLoading = true;
			this.plus_page_key();
			this.$forceUpdate();
			const token = store.getters.jwtToken;
			axios
				.put(
					store.getters.getAPI + '/users/cognito/admin/users/' + this.locum.id + '/reset',
					{
						email: this.locum.email,
					},
					{ headers: { Authorization: token } }
				)
				.then(() => {
					this.desireResetLocumPassword = false;
					this.desireResetLocumPasswordLoading = false;
				})
				.finally(() => {
					this.plus_page_key();
					this.$forceUpdate();
				})
				.catch(() => {
					alert('something went wrong. Please contact a developer.');
				});
		},
		imgLoad(field) {
			this.imgsLoaded[field] = true;
		},
		async unapproveLocum() {
			const token = store.getters.jwtToken;
			let response = await axios.put(
				store.getters.getAPI + '/professionals/manage/' + this.locum.id,
				{
					approved: false,
				},
				{ headers: { Authorization: token } }
			);
			await store.dispatch('setPracticeViewingLocum', response.data.data); //refresh the users state. await it completed.
			this.locum = response.data.data;
			this.plus_page_key();
			this.$forceUpdate();
		},
		async approveLocum() {
			const token = store.getters.jwtToken;
			let response = await axios.put(
				store.getters.getAPI + '/professionals/manage/' + this.locum.id,
				{
					approved: true,
				},
				{ headers: { Authorization: token } }
			);
			await store.dispatch('setPracticeViewingLocum', response.data.data); //refresh the users state. await it completed.
			this.locum = response.data.data;
			this.plus_page_key();
			this.$forceUpdate();
		},
		goBack() {
			bus.$emit('change-main-context', 'LocumSearchTool');
		},
		plus_page_key() {
			this.page_key += 1;
		},
		async getDocs(doctype) {
			const token = store.getters.jwtToken;
			const header = { headers: { Authorization: token } };
			try {
				let response = await axios.get(store.getters.getDOCUMENTS + '/images/' + doctype + '/' + this.locum.id, header);
				return response.data.data;
			} catch (err) {
				console.error(err);
			}
		},
	},
};
</script>
